import { Component, input, computed, inject } from "@angular/core";
import { EvKeyValuePairModule } from "ev-key-value-pair";
import { EvCdkTooltipComponent } from "ev-cdk-tooltip";
import { EvIconTooltipComponent } from "ev-icon-tooltip";
import { OverlayModule } from "@angular/cdk/overlay";
import { ICadastre, IUnit, KeyInfoDto, ShareAppartementInfoDto } from "src/models/estate/key-info.model";
import { CapitalizePipe } from "ev-core";
import { ThreeDotNavigationComponent } from "src/app/shared-components/three-dot-navigation/three-dot-navigation.component";
import { ExternalLinksService } from "src/services/externallinks.service";
import { MenuItem } from "src/services/shared/link-helper.service";
import { INavigationItem, NavigationType } from "src/models/common/navigation-link.model";

@Component({
    selector: "infopage-address-header",
    templateUrl: "./address-header.component.html",
    styleUrls: ["./address-header.component.scss"],
    imports: [EvCdkTooltipComponent, OverlayModule, EvKeyValuePairModule, CapitalizePipe, ThreeDotNavigationComponent, EvIconTooltipComponent],
})
export class InfoPageAddressHeaderComponent {
    externalLinksService = inject(ExternalLinksService);

    keyInfo = input.required<KeyInfoDto | ShareAppartementInfoDto>();
    organization = input<string | undefined>();
    navigationMenuItems = input.required<MenuItem[]>();
    title = input<string | undefined>();
    identityText = input<string | undefined>();
    navigationType = input<NavigationType>(NavigationType.Estate);
    showCadastre = input<boolean>(true);

    titleText = computed(() => {
        if (this.title()) {
            return this.title();
        }
        if (this.keyInfo()?.streetName) {
            return `${this.keyInfo()?.streetName} ${this.keyInfo()?.streetNumber} ${this.keyInfo()?.streetLetter}, ${this.keyInfo()?.postalCode} ${
                this.keyInfo()?.postOfficeName
            }`;
        }
        return this.cadastre();
    });

    cadastreDialogVisible = false;
    identityDialogVisible = false;

    identityTooltipText = 'Andeler i aksjelag og andre useksjonerte boliger identifiseres med bruksenhetsnummer/gateadresse/postnummer.';

    cadastre = computed(() => {
        const keyInfo = this.keyInfo() as any;
        const cadastre: ICadastre | undefined = keyInfo?.cadastre || keyInfo?.parentCadastre;

        if (cadastre == null) return null;

        if (cadastre.gNr && cadastre.bNr) {
            const municipality = (cadastre.kNr.toString() || "0").padStart(4, "0");
            return municipality + "-" + (cadastre.gNr || "0") + "/" + (cadastre.bNr || "0") + "/" + (cadastre.fNr || "0") + "/" + (cadastre.sNr || "0");
        }

        return null;
    });

    cadastreTooltip = computed(() => {
        const keyInfo = this.keyInfo() as any;
        const cadastre: ICadastre | undefined = keyInfo?.cadastre || keyInfo?.parentCadastre;

        if (cadastre == null) return null;

        if (cadastre.gNr && cadastre.bNr) {
            const municipality = (cadastre.kNr.toString() || "0").padStart(4, "0");
            return `Kommunenr: ${municipality} Gnr: ${cadastre.gNr || "0"} Bnr: ${cadastre.bNr || "0"} Fnr: ${cadastre.fNr || "0"} Snr: ${cadastre.sNr || "0"}`;
        }

        return null;
    });

    navigationItem = computed<INavigationItem>(() => {
        const keyInfo = this.keyInfo() as any;
        const cadastre: ICadastre | undefined = keyInfo?.cadastre || keyInfo?.parentCadastre;

        const navItem = {
            navigationType: this.navigationType(),
            latlng: {
                lat: keyInfo.latitude,
                lng: keyInfo.longitude,
            },
            address: this.titleText(),
            cadastre: cadastre,
            unitId: keyInfo.unitId,
            userFeatures: keyInfo.userFeatures,
        };

        return navItem;
    });

    areaInfoLink(area: IUnit): string {
        const href = this.externalLinksService.areaInfoLink(area);
        return href;
    }
}
